import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { ResultScreen } from "../User/Feedback";
import { Icon, OnboardingIcons } from "../User/OnboardingLayout";

/* Même illustration que « Portefeuille rechargé ». */
const ILLUSTRATION = "/assets/imgs/illustration-scooter.png";
const FALLBACK = "/assets/imgs/Delivery_men.png";

/**
 * /stripe-payment-success — page d'arrivée après un paiement Stripe
 * (ancien parcours, plus appelée ni par le backend ni par le mobile) :
 * confirme le paiement et renvoie vers l'app.
 */
const StripePaymentSuccess = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <>
      <OnboardingIcons />
      <ResultScreen
        tone="success"
        halo="medium"
        bubbles={false}
        float={false}
        art="small"
        illustration={ILLUSTRATION}
        fallbackIllustration={FALLBACK}
        badge={
          <>
            <Icon name="check" />
            {t("Payment received")}
          </>
        }
        title={t("Payment confirmed")}
        lede={t("Thank you! You can go back to WOSH.")}
        wideAction
        actions={[{ label: t("Back to home"), onClick: () => history.replace("/home"), primary: true }]}
      />
    </>
  );
};

export default StripePaymentSuccess;
